export const PaginatedBlog = ({ allTags = [], blogTitle = "", shopUrl = "", featuredArticleId = "" }) => ({
  articles: [],
  page: 0,
  totalPages: 0,
  articlesPerPage: 9,
  get filteredArticles() {
    return this.articles.slice(this.articlesPerPage * this.page, this.articlesPerPage * (this.page + 1));
  },
  allBlogTags: allTags,
  filter: null,
  sortOrderReversed: 1,
  searchQuery: "",
  async filterByTag(tag) {
    this.filter = { type: "TAG", value: tag };
  },
  async clearFilters() {
    this.filter = null;
  },
  async getArticles() {
    const response = await fetch(`https://${shopUrl}/api/2021-07/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "3f8f8180c181ba52df88555123a92502",
      },
      body: JSON.stringify({
        query: `{
              articles(first: 100, sortKey: PUBLISHED_AT, reverse: ${
                this.sortOrderReversed == 0 ? false : true
              }, query: "blog_title:${blogTitle}${
          this.filter && this.filter.type === "TAG" ? ` AND tag:${this.filter.value}` : ""
        }${this.searchQuery ? ` AND ${this.searchQuery})` : ""}") {
                edges {
                  node {
                    id
                    handle
                    url: onlineStoreUrl
                    title
                    tags
                    publishedAt
                    author {
                      name
                    }
                    image {
                      id
                      altText
                      url
                      width
                      height
                    }
                    excerpt(truncateAt: 50)
                    content(truncateAt: 50)
                  }
                }
              }
            }`,
      }),
    });

    const data = await response.json();
    const articles = data?.data?.articles?.edges ?? [];

    return articles
      .map(({ node }) => node)
      .filter((article) => !featuredArticleId || !article.id.includes(featuredArticleId));
  },
  async init() {
    const articles = await this.getArticles();
    this.articles = articles;

    this.page = 0;
    this.totalPages = Math.ceil(articles.length / this.articlesPerPage);

    this.$watch("articles", (articles) => {
      this.page = 0;
      this.totalPages = Math.ceil(articles.length / this.articlesPerPage);
    });

    this.$watch("filter", async () => {
      this.articles = await this.getArticles();
    });

    this.$watch("sortOrderReversed", async () => {
      this.articles = await this.getArticles();
    });

    this.$watch("searchQuery", async () => {
      this.articles = await this.getArticles();
    });
  },
});
